import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router';
import { Avatar, Button } from 'antd';
import { BaseForm } from 'components/common/forms/BaseForm/BaseForm';
import notificationHook from 'hooks/notificationHook';
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks';
import { useResponsive } from 'hooks/useResponsive';
import { Dates } from 'constants/Dates';
import { doLogin } from 'store/slices/authSlice';
import { loginFormInitValues } from 'constants/initialValues';
import statusMessages from 'statusMessages';
import { InputPassword } from 'components/common/inputs/InputPassword/InputPassword';
import 'styles/sass/auth-layout.scss';
import 'styles/sass/lock-form.scss';
import { ApiError } from 'types';

interface LockFormData {
  password: string;
}

const initValues = {
  password: loginFormInitValues.password,
};

export const LockForm: React.FC = () => {
  const navigate = useNavigate();
  const { mobileOnly } = useResponsive();
  const dispatch = useAppDispatch();

  const [isLoading, setLoading] = useState(false);
  const [dateState, setDateState] = useState(new Date());
  const user = useAppSelector((state) => state.auth.user);
  const fullName = `${user?.name}`;

  const currentDateInUTC = dateState.toUTCString();
  const currentTime = Dates.format(currentDateInUTC, 'h:mm A');
  const currentDate = Dates.format(currentDateInUTC, 'dddd, MMMM D, YYYY');

  useEffect(() => {
    const interval = setInterval(() => setDateState(new Date()), 10 * 1000);
    return () => clearInterval(interval);
  }, []);

  const handleSubmit = ({ password }: LockFormData) => {
    setLoading(true);
    dispatch(doLogin({ email: user?.email || '', password }))
      .unwrap()
      .then(() => {
        navigate(-1);
      })
      .catch((error) => {
        const currentStatus = (error as ApiError).statusCode;
        notificationHook({
          type: 'error',
          message: statusMessages.user[
            currentStatus ? currentStatus : 500
          ] as string,
        });
        setLoading(false);
      });
  };

  return (
    <div className="form-wrapper">
      <BaseForm
        layout="vertical"
        onFinish={handleSubmit}
        requiredMark="optional"
        initialValues={initValues}
      >
        <div className="content-wrapper">
          <div className="form-time">{currentTime}</div>
          <div className="form-date">{currentDate}</div>
          <div className="avatar-circle">
            <Avatar
              src={user?.profile_picture}
              alt="user avatar"
              size={mobileOnly ? 59 : 77}
            />
          </div>
          <div className="form-name">{fullName}</div>
        </div>
        <BaseForm.Item
          className="form-time"
          label={`Contraseña`}
          name="password"
          rules={[{ required: true, message: `Campo requerido` }]}
        >
          <InputPassword
            className="form-input-password"
            placeholder={`Contraseña`}
          />
        </BaseForm.Item>
        <BaseForm.Item noStyle>
          <Button
            className="submit-button"
            type="primary"
            htmlType="submit"
            loading={isLoading}
          >
            {`Ingresar`}
          </Button>
        </BaseForm.Item>
      </BaseForm>
    </div>
  );
};
